import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { popIn } from '@common/utils/services';
import SpaceForm from '../Form';
import { fetchSpace, updateSpace, clearSpace } from '@resources/Space/actions';
import { Title, Modal } from '@common/components';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Update = (props) => {
	const {
		fetchSpace,
		space,
		updateSpace,
		visible,
		clearSpace,
		module,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchSpace(visible);
		};
		visible ? fetchData() : clearSpace();
	}, [fetchSpace, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateSpace(space._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.space.update',
							defaultMessage:
								'An existing Space entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[space]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.space',
					defaultMessage: 'Update Space',
				})}
			</Title>
			{!isEmpty(space) && (
				<SpaceForm
					data={space}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	space,
	event,
	facility,
	ministry,
	mission,
	organization,
	modules,
}) => {
	return {
		space,
		event,
		facility,
		ministry,
		mission,
		organization,
		modules,
	};
};

export default connect(mapStateToProps, {
	fetchSpace,
	updateSpace,
	fetchModulesBySubmoduleCode,
	clearSpace,
})(Update);
